// src/version.js
export const APP_VERSION = "v1.4.2";